// Added By : bhautik
// Created At: 31-5-2024
// Description: orgStructureSlice
// Ticket ID: 005
import { createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import {

  addorgFile,
  deleteUnit,
  deletejobPostion,
  getEducationalOptions,
  getForeignLangugeOptions,
  getLocation,
  getSpecialRequiremntOptions,
  getUnit,
  getUnitSaleSectore,
  getrequiredKnowledgeAndSkilloptions,
  getverstionhistory,
  jobPostionGetByid,
  jobPostiondetailsview,
  orgAddJobPosition,
  orgAddUnit,
  orgStructure,
  updateJobPostion,
  updateOrgUnit,
  updatecurrentVerstions,
  getJobPositions,
  addJobPosition,
  getUserProfileById,
  getAllUserProfiles,
  updateUserProfile,
  getVersionParameterValues,
  getDisciplinaryMeasureById,
  getDisciplinaryMeasures,
  getBenefits,
  getContracts,
  getUsersChart,
  getWorkShifts,
  getAvailableJobPositions,
  getUserAttendances,
  getWorkShiftById,
  deleteWorkShift,
  updateWorkShift,
  addWorkShift,
  getUserAbsences,
  deleteUserProfile,
} from "../../Api/services/org-StructureService";

const orgStructureSlice = createSlice({
  name: "organizationalStructure",
  initialState: {
    orgStructureData: null,
    jobPositionSingledata: [],
    unitOptions: [],
    jobPositionOptions: [],
    availableJobPositionOptions: [],
    locationOptions: [],
    foreignLangugeData: [],
    eduactionQulificationData: [],
    skilOptionsData: [],
    saleSectoreData: [],
    specialRequirmentOptionsData: [],
    verstionHistoryData: null,
    error: null,
    loading: false,
    jobpostionloaidng: false,
    jobpositionsloading: false,
    jobPostionDetailLoader: false,
    verstionloading: false,
    userProfilesData: [],
    singleDataLoading: false,
    userProfileSingleData: [],
    versionParameterValues: {},
    userContracts: [],
    userDisciplinaryMeasures: [],
    userBenefits: [],
    usersChartData: [],
    workShifts: [],
    userAttendances: null,
    singleWorkShiftData: [],
    userAbsences: [],
    singleUserAbsences: [],
    singleUserPlannedAbsences: [],
    singleUserPendingAbsences: [],
  },
  reducers: {
    resetUserProfileSingleData: (state) => {
      state.userProfileSingleData = [];
    },
    setUserProfileSingleData: (state, action) => {
      state.userProfileSingleData = action.payload;
    },
  },
  extraReducers: (builder) => {
    //orgStructureData
    builder
      .addCase(orgStructure.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(orgStructure.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          //toast.success(action?.payload?.message);
        }
        return {
          ...state,
          orgStructureData: action.payload,
          loading: false,
        };
      })
      .addCase(orgStructure.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //get add unit options
    builder
      .addCase(getUnit.pending, (state) => {
        return {
          ...state,
          // loading: true,
        };
      })
      .addCase(getUnit.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error("error login");
        } else {
          //toast.success("User Login successfuly");
        }
        return {
          ...state,
          unitOptions: action.payload.data.units,
          // loading: false,
        };
      })
      .addCase(getUnit.rejected, (state, action) => {
        return {
          ...state,
          // loading: false,
          error: action.payload,
        };
      });
    //sale sectore data
    builder
      .addCase(getUnitSaleSectore.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getUnitSaleSectore.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        } else {
          //toast.success("User Login successfuly");
        }
        return {
          ...state,
          saleSectoreData: action.payload,
          loading: false,
        };
      })
      .addCase(getUnitSaleSectore.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //job postions data
    builder
      .addCase(getJobPositions.pending, (state) => {
        return {
          ...state,
          jobpositionsloading: true,
        };
      })
      .addCase(getJobPositions.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          //toast.success(action?.payload?.message);
        }
        return {
          ...state,
          jobpositionsloading: false,
          jobPositionOptions: action?.payload?.data?.job_positions,
        };
      })
      .addCase(getJobPositions.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          jobpositionsloading: false,
          error: action.payload,
        };
      });
    //available job positions data
    builder
      .addCase(getAvailableJobPositions.pending, (state) => {
        return {
          ...state,
          jobpositionsloading: true,
        };
      })
      .addCase(getAvailableJobPositions.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          //toast.success(action?.payload?.message);
        }
        return {
          ...state,
          jobpositionsloading: false,
          availableJobPositionOptions: action?.payload?.data?.job_positions,
        };
      })
      .addCase(getAvailableJobPositions.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          jobpositionsloading: false,
          error: action.payload,
        };
      });
    //job postion signle data
    builder
      .addCase(jobPostionGetByid.pending, (state) => {
        return {
          ...state,
          jobpostionloaidng: true,
        };
      })
      .addCase(jobPostionGetByid.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          //toast.success(action?.payload?.message);
        }
        return {
          ...state,
          jobpostionloaidng: false,
          jobPositionSingledata: action.payload,
        };
      })
      .addCase(jobPostionGetByid.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          jobpostionloaidng: false,
          error: action.payload,
        };
      });
    //options data

    //foreign lanaguge data
    builder
      .addCase(getForeignLangugeOptions.pending, (state) => {
        return {
          ...state,
          //loading: true,
        };
      })
      .addCase(getForeignLangugeOptions.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          foreignLangugeData: action?.payload?.data,
        };
      })
      .addCase(getForeignLangugeOptions.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          //loading: false,
          error: action.payload,
        };
      });
    //get eduaction qulification data
    builder
      .addCase(getEducationalOptions.pending, (state) => {
        return {
          ...state,
        };
      })
      .addCase(getEducationalOptions.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          eduactionQulificationData: action?.payload?.data,
        };
      })
      .addCase(getEducationalOptions.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          error: action.payload,
        };
      });
    //skill options
    builder
      .addCase(getrequiredKnowledgeAndSkilloptions.pending, (state) => {
        return {
          ...state,
          //loading: true,
        };
      })
      .addCase(
        getrequiredKnowledgeAndSkilloptions.fulfilled,
        (state, action) => {
          if (action?.payload?.status === false) {
            toast.error(action.payload);
          } else {
            // toast.success("get data successfuly");
          }
          return {
            ...state,
            skilOptionsData: action?.payload?.data,
            //loading: false,
          };
        }
      )
      .addCase(
        getrequiredKnowledgeAndSkilloptions.rejected,
        (state, action) => {
          toast.error(action.payload);
          return {
            ...state,
            //loading: false,
            error: action.payload,
          };
        }
      );
    //special requirement options
    builder
      .addCase(getSpecialRequiremntOptions.pending, (state) => {
        return {
          ...state,
          //loading: true,
        };
      })
      .addCase(getSpecialRequiremntOptions.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          specialRequirmentOptionsData: action?.payload?.data,
        };
      })
      .addCase(getSpecialRequiremntOptions.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          error: action.payload,
        };
      });

    //delete unit
    builder
      .addCase(deleteUnit.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(deleteUnit.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(deleteUnit.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //delete job postions
    builder
      .addCase(deletejobPostion.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(deletejobPostion.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(deletejobPostion.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    //get locations optins
    builder
      .addCase(getLocation.pending, (state) => {
        return {
          ...state,
          // loading: true,
        };
      })
      .addCase(getLocation.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error("error login");
        } else {
          //toast.success("User Login successfuly");
        }
        return {
          ...state,
          locationOptions: action.payload,
          // loading: false,
        };
      })
      .addCase(getLocation.rejected, (state, action) => {
        return {
          ...state,
          // loading: false,
          error: action.payload,
        };
      });

    //add unit
    builder
      .addCase(orgAddUnit.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(orgAddUnit.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(orgAddUnit.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //add job position data
    builder
      .addCase(orgAddJobPosition.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(orgAddJobPosition.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(orgAddJobPosition.rejected, (state, action) => {
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    //update unit
    builder
      .addCase(updateOrgUnit.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(updateOrgUnit.fulfilled, (state, action) => {
        if (action?.payload?.success === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(updateOrgUnit.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //update job postion data
    builder
      .addCase(updateJobPostion.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(updateJobPostion.fulfilled, (state, action) => {
        if (action?.payload?.success === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(updateJobPostion.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //file OU upload
    builder
      .addCase(addorgFile.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(addorgFile.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          //toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(addorgFile.rejected, (state, action) => {
        //toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //file JP upload
    builder
      .addCase(addJobPosition.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(addJobPosition.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          //toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(addJobPosition.rejected, (state, action) => {
        //toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //job postion details view page
    builder
      .addCase(jobPostiondetailsview.pending, (state) => {
        return {
          ...state,
          jobPostionDetailLoader: true,
        };
      })
      .addCase(jobPostiondetailsview.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          //toast.success(action?.payload?.message);
        }
        return {
          ...state,
          jobPostionDetailLoader: false,
          jobPositionSingledata: action.payload,
        };
      })
      .addCase(jobPostiondetailsview.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          jobPostionDetailLoader: false,
          error: action.payload,
        };
      });

    //vestion history get data
    builder
      .addCase(getverstionhistory.pending, (state) => {
        return {
          ...state,
          verstionloading: true,
        };
      })
      .addCase(getverstionhistory.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          //toast.success(action?.payload?.message);
        }
        return {
          ...state,
          verstionHistoryData: action.payload,
          verstionloading: false,
        };
      })
      .addCase(getverstionhistory.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          verstionloading: false,
          error: action.payload,
        };
      });

    //update current verstions
    builder
      .addCase(updatecurrentVerstions.pending, (state) => {
        return {
          ...state,
          verstionloading: true,
        };
      })
      .addCase(updatecurrentVerstions.fulfilled, (state, action) => {
        if (action?.payload?.success === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          verstionloading: false,
        };
      })
      .addCase(updatecurrentVerstions.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          verstionloading: false,
          error: action.payload,
        };
      });

    //get version parameter values
    builder
      .addCase(getVersionParameterValues.pending, (state) => {
        return {
          ...state,
          verstionloading: true,
        };
      })
      .addCase(getVersionParameterValues.fulfilled, (state, action) => {
        if (action?.payload?.success === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          versionParameterValues: action.payload,
          verstionloading: false,
        };
      })
      .addCase(getVersionParameterValues.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          verstionloading: false,
          error: action.payload,
        };
      });

    //get user by id
    builder
      .addCase(getUserProfileById.pending, (state) => {
        return {
          ...state,
          singleDataLoading: true,
        };
      })
      .addCase(getUserProfileById.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          userProfileSingleData: action.payload,
          singleDataLoading: false,
        };
      })
      .addCase(getUserProfileById.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          singleDataLoading: false,
          error: action.payload,
        };
      });
    //get user profiles list
    builder
      .addCase(getAllUserProfiles.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getAllUserProfiles.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          userProfilesData: action.payload.data,
          loading: false,
        };
      })
      .addCase(getAllUserProfiles.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    // update user profile
    builder
      .addCase(updateUserProfile.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        toast.success("User profile updated successfully");
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //delete user
    builder
    .addCase(deleteUserProfile.pending, (state) => {
      state.loading=true;
    })
    .addCase(deleteUserProfile.fulfilled, (state) => {
      state.loading=false;
    })
    .addCase(deleteUserProfile.rejected, (state,action) => {
      state.loading = false;
      state.error = action.payload;
    })
    // get disciplinary measures by id
    builder
      .addCase(getDisciplinaryMeasureById.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getDisciplinaryMeasureById.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          loading: false,
          // TODO add a place to store the data
          // xxxx: action.payload,
        };
      })
      .addCase(getDisciplinaryMeasureById.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    // get disciplinary measures
    builder
      .addCase(getDisciplinaryMeasures.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getDisciplinaryMeasures.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          loading: false,
          userDisciplinaryMeasures: action.payload.data,
        };
      })
      .addCase(getDisciplinaryMeasures.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    // get benefits
    builder
      .addCase(getBenefits.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getBenefits.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          loading: false,
          userBenefits: action.payload.data,
        };
      })
      .addCase(getBenefits.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    // get contracts
    builder
      .addCase(getContracts.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getContracts.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          loading: false,
          userContracts: action.payload.data,
        };
      })
      .addCase(getContracts.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    // get chart data
    builder
      .addCase(getUsersChart.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getUsersChart.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          loading: false,
          usersChartData: action.payload.data,
        };
      })
      .addCase(getUsersChart.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    // get work shifts
    builder
      .addCase(getWorkShifts.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getWorkShifts.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          loading: false,
          workShifts: action.payload.data,
        };
      })
      .addCase(getWorkShifts.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //get work shift by id
    builder
      .addCase(getWorkShiftById.pending, (state) => {
        return {
          ...state,
          singleDataLoading: true,
        };
      })
      .addCase(getWorkShiftById.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          singleWorkShiftData: action.payload.data,
          singleDataLoading: false,
        };
      })
      .addCase(getWorkShiftById.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          singleDataLoading: false,
          error: action.payload,
        };
      });

    // Add work shift
    builder
      .addCase(addWorkShift.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(addWorkShift.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(addWorkShift.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    // Update work shift
    builder
      .addCase(updateWorkShift.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(updateWorkShift.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(updateWorkShift.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    // Delete work shift
    builder
      .addCase(deleteWorkShift.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(deleteWorkShift.fulfilled, (state, action) => {
        if (action?.payload?.success === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(deleteWorkShift.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    //get user attendances
    builder
      .addCase(getUserAttendances.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserAttendances.fulfilled, (state, action) => {
        const { type, data } = action.payload;

        state.loading = false;
        if (data?.status === false) {
          toast.error(data?.message);
          return;
        }

        switch (type) {
          case "all":
            state.userAttendances = data?.data;
            break;
          case "calendar-view":
            state.employeeAttendance = data?.data;
            break;
          default:
            console.warn(`Unhandled type: ${type}`);
            break;
        }
      })
      .addCase(getUserAttendances.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        toast.error(action.payload);
      });

    //get user absences
    builder
      // Handle pending state
      .addCase(getUserAbsences.pending, (state) => {
        state.loading = true;
      })
      // Handle fulfilled state
      .addCase(getUserAbsences.fulfilled, (state, action) => {
        const {
          data: { data },
          type,
        } = action.payload;

        state.loading = false;
        switch (type) {
          case "all":
            state.userAbsences = data;
            break;
          case "single":
            state.singleUserAbsences = data;
            break;
          case "pending":
            state.singleUserPendingAbsences = data;
            break;
          case "planned":
            state.singleUserPlannedAbsences = data;
            break;
          default:
            break;
        }
      })
      // Handle rejected state
      .addCase(getUserAbsences.rejected, (state, action) => {
        const { error, type } = action.payload;
        state.loading = false;
        state.error = error;

        // Optionally clear data for the specific type on failure
        switch (type) {
          case "all":
            state.userAbsences = [];
            break;
          case "single":
            state.singleUserAbsences = [];
            break;
          case "pending":
            state.singleUserPendingAbsences = [];
            break;
          case "planned":
            state.singleUserPlannedAbsences = [];
            break;
          default:
            break;
        }
      });
  },
});
export { getAllUserProfiles, deleteUserProfile };
export const { resetUserProfileSingleData, setUserProfileSingleData } =
  orgStructureSlice.actions;
export default orgStructureSlice.reducer;
